export default __webpack_public_path__ + "static/media/userIcon.2bd9fcaf.svg";